import { GlitchNumber } from "./GlitchNumber";

interface Props { N: bigint | number }

export function MissionGoalBox({ N }: Props) {
  const str = N.toLocaleString("pl-PL");
  const len = str.length;

  let fontSize = 80;
  if (len > 8) fontSize = 64;
  if (len > 12) fontSize = 48;
  if (len > 16) fontSize = 36;
  if (len > 22) fontSize = 28;
  if (len > 30) fontSize = 22;

  return (
    <div className="mission-goal">
      <span className="mission-label">⚡ Mission Briefing</span>
      <div className="mission-title">Cel misji</div>
      <GlitchNumber value={str} fontSize={fontSize} />
      <span className="mission-suffix">Owiec do wysłania 🐑</span>
    </div>
  );
}
